import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useVerifyTokenMutation, useResendEmailVerificationMutation } from '../../redux/api/authApi';
import MetaData from '../layout/MetaData';
import toast from 'react-hot-toast';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [cooldown, setCooldown] = useState(0);

  const [verifyToken, { isLoading, error, isSuccess }] = useVerifyTokenMutation();
  const [resendVerification, { isLoading: isResending }] = useResendEmailVerificationMutation();
  const storedEmail = localStorage.getItem('pendingEmail');

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success('Email Verified successfully');
      toast.success('Phone Verification token sent to your number', { duration: 10000 });
      localStorage.removeItem('pendingEmail');
      navigate('/verify-phone');
    }
  }, [error, isSuccess, navigate]);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await verifyToken({ code: value });
  };

  const handleResend = async () => {
    if (!storedEmail) {
      toast.error('No email found. Please register again.');
      return;
    }
    try {
      await resendVerification({ type: 'email', email: storedEmail }).unwrap();
      toast.success('Verification email resent successfully');
      setCooldown(30);
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to resend verification email');
    }
  };

  return (
    <>
      <MetaData title="Email Verification" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={handleSubmit}>
            <h2 className="mb-4 text-center">Email Verification</h2>

            <div className="mb-3">
              <label htmlFor="value_field" className="form-label">Verification Code</label>
              <input
                type="text"
                id="value_field"
                className="form-control"
                name="value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Enter 6-digit code"
                maxLength={6}
                required
              />
            </div>

            <button id="login_button" type="submit" className="btn btn-primary w-100 py-2" disabled={isLoading}>
              {isLoading ? 'Verifying...' : 'Verify Email'}
            </button>

            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-outline-primary w-100 py-2"
                onClick={handleResend}
                disabled={isResending || cooldown > 0}
              >
                {isResending
                  ? '⏳ Resending...'
                  : cooldown > 0
                    ? `⏳ Resend in ${cooldown}s`
                    : '🔄 Resend Verification Email'
                }
              </button>
            </div>

            <div className="text-center mt-4">
              <Link to="/login">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;